<ngx-skeleton-loader [theme]="{ height: '70px' }" />
<ngx-skeleton-loader [theme]="{ height: '100px' }" />
<ngx-skeleton-loader [theme]="{ height: '100px' }" />
<ngx-skeleton-loader [theme]="{ height: '100px' }" />
<app-skeleton-table [showFilters]="false" [showTabs]="false" />
